// constants/appVersion.js
// Update these with every release to match the native project versions:
//   iOS:     Info.plist CFBundleShortVersionString
//   Android: build.gradle versionName / versionCode

export const APP_VERSION = {
  ios: '1.3.4',
  iosBuild: 21,
  android: '2.1.8',
  androidBuildNumber: 16,
};
